import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { FieldTypes } from '../../FieldTypes';
import { GlobalsService } from '../../services/globals.service';
import { FormItem } from '../form/FormItem';

@Component({
  selector: 'vias-approval-processes-dialog',
  templateUrl: './approval-processes-dialog.component.html',
  styleUrls: ['./approval-processes-dialog.component.scss']
})
export class ApprovalProcessesDialogComponent {
  // 2800 
  numLocale: string;
  pid: number;
  pageName: string;
  approvalPersons: object[] = [];
  approvalCount: number = 0;
  headData: any;
  formItems: FormItem[] = [];
  formRefx;
  @ViewChild('formApproval', { static: false }) set formRef(formApproval: ElementRef | null) {
    if (!formApproval) { return; }
    this.formRefx = formApproval;
  }
  constructor(protected globals: GlobalsService,
    protected translate: TranslateService,
    public dialogRef: MatDialogRef<ApprovalProcessesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.numLocale = this.globals.numLocale;
    if (data.pid !== undefined) {
      this.pid = Number(data.pid);
    }
    if (data.pageName !== undefined) {
      this.pageName = data.pageName;
    }
    if (data.data !== undefined) {
      this.headData = data.data;
    }
    if (data.approvalPersons !== undefined) {
      this.approvalPersons = data.approvalPersons;
    }
    for (let ix = 1; ix <= this.approvalPersons.length; ix++) {
      let confirmUser = false;
      const status = Number(this.headData.status);
      if (this.pid === 2800) {//Purchase Orders
        if (Number(this.approvalPersons[ix - 1]['id']) === Number(sessionStorage.getItem('userId')) &&
          ((ix === 1 && status === 0) ||
            (ix === 2 && status === 6) ||
            (ix === 3 && status === 8) ||
            (ix === 4 && status === 9))) {
          confirmUser = true;
          this.approvalCount = ix;
        } else {
          confirmUser = false;
        }
      } else if (this.pid === 8600 || this.pid === 8900) {//Discovery Account Forms - Shipyard Account Forms
        let first: boolean = true;
        const subStatus = Number(this.approvalPersons[ix - 1]['approval_status']);
        if (subStatus === 9) {
          if (Number(this.approvalPersons[ix - 1]['updated_by']) === Number(sessionStorage.getItem('userId')) &&
            ((ix === 1 && Number(this.approvalPersons[ix - 1]['approved_by1']) === 0) ||
              (ix === 2 && Number(this.approvalPersons[ix - 1]['approved_by2']) === 0) ||
              (ix === 3 && Number(this.approvalPersons[ix - 1]['approved_by3']) === 0) ||
              (ix === 4 && Number(this.approvalPersons[ix - 1]['approved_by4']) === 0) ||
              (ix === 5 && Number(this.approvalPersons[ix - 1]['approved_by5']) === 0)) && first) {
            first = false;
            confirmUser = true;
            this.approvalCount = ix;
          }else{
            confirmUser = false;
          }
        } else if (Number(this.approvalPersons[ix - 1]['id']) === Number(sessionStorage.getItem('userId')) &&
          ((ix === 1 && subStatus === 0) ||
            (ix === 2 && subStatus === 6) ||
            (ix === 3 && subStatus === 7) ||
            (ix === 4 && subStatus === 8)||
            (ix === 5 && subStatus === 10))) {
              confirmUser = true;
              this.approvalCount = ix;
        }else{
          confirmUser = false;
        }
      }
      this.formItems.push({
        type: FieldTypes.Text,
        label: 'approver_' + ix.toString(),
        name: 'approvedBy' + ix.toString(),
        disabled: true,
        value: this.approvalPersons[ix - 1]['name'],
        componentFixedWidth: 2
      });
      this.formItems.push({
        type: FieldTypes.Text,
        label: 'notes',
        name: 'approvedNote' + ix.toString(),
        disabled: !confirmUser,
        multiline: true,
        componentFixedWidth: 2
      });
      if (confirmUser) {
        this.formItems.push({
          type: FieldTypes.Button,
          label: 'confirm',
          name: 'confirm',
          icon: true,
          icon_type: 'check',
          iconClick($event): void { }
        });
        this.formItems.push({
          type: FieldTypes.Button,
          label: 'deny',
          name: 'deny',
          icon: true,
          icon_type: 'close',
          color: 'warn',
          iconClick($event): void { }
        });
        if(this.pid === 8600 || this.pid === 8900){
          this.formItems.push({
            type: FieldTypes.Button,
            label: 'waited',
            name: 'wait',
            icon: true,
            icon_type: 'hourglass_empty',
            color: 'accent',
            iconClick($event): void { }
          });
        }
      }
      let val = '';
      if(this.pid === 8600 || this.pid === 8900){
        val = this.approvalPersons[ix - 1]['approved_note' + ix.toString()];
      }else{
        val = ix === 1 ? this.headData['remarks'] : this.headData['remarks' + ix.toString()];
      }
      this.formItems.find(fi => fi.name === 'approvedNote' + ix.toString()).value = val;
    }
    this.formItems.forEach(e => {
      this.translate.get(e.label).subscribe((translated: string) => {
        e.label = translated;
      });
    });
  }
  formItemIconClickHandler($event): void {
    if ($event.name === 'confirm') {
      this.dialogRef.close({ confirm: true, notes: this.formRefx.value['approvedNote' + this.approvalCount.toString()] });
    }
    if ($event.name === 'deny') {
      this.dialogRef.close({ deny: true, notes: this.formRefx.value['approvedNote' + this.approvalCount.toString()] });
    }
    if ($event.name === 'wait') {
      this.dialogRef.close({ wait: true, notes: this.formRefx.value['approvedNote' + this.approvalCount.toString()] });
    }
  }
}